import { useCallback, useEffect, useState } from 'react';

const KEY = 'gc_recently_viewed';
const MAX = 12;

export interface RecentItem {
  id: string;
  name: string;
  image: string;
  price: number;
  handle?: string;
}

const read = (): RecentItem[] => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const useRecentlyViewed = () => {
  const [items, setItems] = useState<RecentItem[]>(read);

  useEffect(() => {
    const sync = () => setItems(read());
    window.addEventListener('storage', sync);
    window.addEventListener('gc:recent', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('gc:recent', sync);
    };
  }, []);

  const record = useCallback((item: RecentItem) => {
    setItems((prev) => {
      const next = [item, ...prev.filter((p) => p.id !== item.id)].slice(0, MAX);
      localStorage.setItem(KEY, JSON.stringify(next));
      window.dispatchEvent(new Event('gc:recent'));
      return next;
    });
  }, []);

  return { items, record };
};
